export default __webpack_public_path__ + "static/media/icon_language.08197e65.svg";